/**
 * UI Highlight — pulsing blue border overlay on target element.
 * Uses a position:fixed div so it's never clipped by parent overflow
 * or stacking context issues.
 */

let overlayEl: HTMLElement | null = null;
let targetEl: HTMLElement | null = null;
let rafId: number | null = null;

export function applyHighlight(selector: string): void {
  removeHighlight();
  const el = document.querySelector<HTMLElement>(selector);
  if (!el) return;
  targetEl = el;

  overlayEl = document.createElement('div');
  overlayEl.className = 'ent-highlight-overlay';
  document.body.appendChild(overlayEl);

  positionOverlay();
  // Continuously reposition in case of layout shifts
  const track = () => {
    positionOverlay();
    rafId = requestAnimationFrame(track);
  };
  rafId = requestAnimationFrame(track);
}

export function removeHighlight(): void {
  if (rafId !== null) {
    cancelAnimationFrame(rafId);
    rafId = null;
  }
  if (overlayEl) {
    overlayEl.remove();
    overlayEl = null;
  }
  targetEl = null;
}

function positionOverlay(): void {
  if (!overlayEl || !targetEl) return;
  const rect = targetEl.getBoundingClientRect();
  overlayEl.style.left = `${rect.left}px`;
  overlayEl.style.top = `${rect.top}px`;
  overlayEl.style.width = `${rect.width}px`;
  overlayEl.style.height = `${rect.height}px`;
}
